
























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { AutocompleteResult } from '@/models/BookMeetingFlow';
import { websiteText } from '@/mixins/websiteTexts';

@Component
class AutocompleteList extends Vue {
    @Prop() items!: AutocompleteResult[];
    @Prop({ default: -1 }) readonly selectedIndex!: number;
    @Prop({ default: false }) readonly shouldShowYourLocation!: boolean;
    @Prop({ default: false }) readonly isSlowTyper!: boolean;
    @Prop() autoCompleteTopMobile!: boolean;
    @Prop({ default: 'quick-search-location-listbox' }) listboxId!: string;
    @Prop({ default: '' }) itemPrefix!: string;

    constructor() {
        super();
    }

    public websiteText = websiteText;

    @Emit('item-selected')
    public onItemClick(result: AutocompleteResult) {
        return result;
    }

    @Emit('update-index')
    public onItemHover(index: number) {
        return index;
    }
}

export default AutocompleteList;
